import { ComponentType } from 'react';
import { useSaveEventProductVerticalsMutation } from '@graphql/generated';
import { useCreateEventState } from '@shared/createEvent/CreateEventState';

export enum SurveyItems {
  WEB_SITE = 'website',
  REGISTRY = 'registry',
  INVITATION_SAVE_THE_DATES = 'invitation_save_the_dates',
  GUEST_LIST_RSVP = 'guestList_rsvp'
}

export type SurveyOptions = {
  id: SurveyItems;
  labelKey: string;
  SurveyOptionIcon: ComponentType;
};

export interface EventProductVerticals {
  selectedOptions: Partial<Record<SurveyOptions['id'], boolean>>;
}

export const useEventProductVerticals = () => {
  const { addEventCreatedListener } = useCreateEventState();
  const [saveEventProductVerticals] = useSaveEventProductVerticalsMutation();

  const updateEventProductVerticals = async ({ selectedOptions }: EventProductVerticals) => {
    addEventCreatedListener(async event => {
      const eventId = event.createEventV0301?.id;
      if (eventId) {
        let payload = {
          optOutOfGuestList: !selectedOptions.guestList_rsvp,
          optOutOfInvites: !selectedOptions.invitation_save_the_dates,
          optOutOfRegistry: !selectedOptions.registry,
          optOutOfWebsite: !selectedOptions.website
        };

        if (!Object.keys(selectedOptions).length) {
          payload = {
            optOutOfGuestList: false,
            optOutOfInvites: false,
            optOutOfRegistry: false,
            optOutOfWebsite: false
          };
        }

        await saveEventProductVerticals({ variables: { eventId, payload } });
      }
    });
  };

  return updateEventProductVerticals;
};
